import React from 'react';

import { Svg, type SvgProps } from './svg';

export function ChevronIcon(props: SvgProps) {
  return (
    <Svg data-testid="chevron-icon" {...props}>
      <path d="m7.4 8.6 4.6 4.6 4.6-4.6L18 10l-6 6-6-6 1.4-1.4Z" />
    </Svg>
  );
}
